module.exports = __webpack_public_path__ + "static/img/jianzhu01.936eb57.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Content/Friend/jianzhu01.png
// module id = WSsl
// module chunks = 12